module.exports = __webpack_public_path__ + "img/150-2.803310f9.jpg";